import ProfissionaisDeApoioIndex from "../Pages/ProfissionaisDeApoio/index.vue";
import NewEditProfissionalDeApoioPage from "../Pages/ProfissionaisDeApoio/NewEditProfissionalDeApoioPage.vue";

export default [
  {
    path: "/profissionais-de-apoio/",
    name: "profissionaisDeApoio",
    component: ProfissionaisDeApoioIndex,
  },
  {
    path: "/profissionais-de-apoio/create",
    name: "profissionaisDeApoio.create",
    component: NewEditProfissionalDeApoioPage,
    props: { editing: false },
  },
  {
    path: "/profissionais-de-apoio/edit/:profissionalDeApoio_id",
    name: "profissionaisDeApoio.edit",
    component: NewEditProfissionalDeApoioPage,
    props: { editing: true },
  },
];
